
<div class="overlay-container" >
</div>
<div class="modal show" id="myModal"  [ngClass]="isPopupOpen?'show':'hide'">
  <div class="modal-dialog modal-lg">
    <div class="modal-content modal-bg">
      <!-- Modal body -->
      <div class="modal-body">
        <button type="button" class="close popupClose" data-dismiss="modal" (click)="close()"><img src="{{globalService.staticResourceURL}}/assets/images/Icon-icon-placeholder.svg" class="img-fluid"></button>
        <div id="addorUpdat" class="mt-4 mb-4">Choose Your Plate</div>
          
         <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
                {{errorMessage}}
            </div>
            <section *ngIf="plateData">
                <div  class="col-12 plateChangeHd mt-4">You've chosen the following plate change:</div>
                <dmv-plate-change 
                        [registrationNumber]="registrationNumber" 
                        [newAltText]="plateData?.newAltText" 
                        [plateStyleNetChange]="plateData?.plateStyleNetChange" 
                        [newImageCode]="plateData?.newImageCode" 
                        [plateStyleProcessingCost]="plateData?.plateStyleProcessingCost" 
                        [plateStyleRepLacementFee]="plateData?.plateStyleRepLacementFee" 
                        [newPlateStyleCost]="plateData?.newPlateStyleCost" 
                        ></dmv-plate-change>
                <div class="row no-margin">
                    <div class="col-12 col-sm-12 mb-4 fsize-md">
                        Would you like to continue with this plate change?
                    </div>
                            <div class="col-12 col-sm-12 mb-3">
                                <a>
                                    <button class="btn btn-primary btn-commonbtn m-auto" (click)="yes()">Yes </button>
                                </a>
                         </div> 
                            <div class="col-12 col-sm-12 mb-3">
                                <a>
                                    <button class="btn btn-primary btn-commonbtn m-auto"  (click)="no()" >No</button>
                                </a>
                         </div>  
                  </div>   
            </section>
            <section *ngIf="!plateData">
            <div class="row no-margin" *ngIf="!errorMessage">
                <div class="col-12 col-sm-12 mb-3">
                    <div class="select-wrapper-3 m-auto" *ngIf="!allowSpecialtyTag">
                       <select class="form-control" required="required"   >
                                <option  [value]="tagCategories[0].tagCategoryID" >{{tagCategories[0].name}}</option>
                            </select>
                    </div>
                    <div class="select-wrapper-3 m-auto" *ngIf="allowSpecialtyTag && tagCategories?.length>0">
                       <select class="form-control" [value]="currentTag?.tagCategoryID || 0" (change)="changeCatagory($event)"  (click)="selectChange($event)" (keydown)="selectChangeByKey($event)"  (blur)="setDownIcon($event)">
                                <option  [value]="tagCategory.tagCategoryID" *ngFor="let tagCategory of tagCategories"> 
                           {{tagCategory.name}}</option>
                            </select>
                    </div>
                </div>
            <div *ngIf="filterTagCatalogData?.length===0 || tagCategories?.length === 0" class="col-12 col-sm-12 mb-3">
                <div class="alert alert-danger">No catalog data available.</div>
                
            </div>
               
                <div class="col-12 col-sm-12 mb-3" *ngIf="filterTagCatalogData?.length>0" >
                    <div class="select-wrapper-3 select-overlay-plate m-auto" id="select-overlay-plate"  [ngClass]="isDropdownOpen?'upArrow':'downArrow'">
                        <div class="select-overlay-input" (click)="openDropDown(isDropdownOpen)" id="select-overlay-input">

                           <span *ngIf="tag && tag.tagCode && tag.imageCode && tag.name" class="tagImageInput">
                                <img src="{{globalService.externalResourcesUrl}}dmv/{{getImage(tag.tagCode)}}.jpg" class="selectbox-icom tagImageInput" alt="{{tag.name}}"/>
                            </span>
                            <span  class="noTag tagImageInput" *ngIf="!(tag && tag.tagCode && tag.imageCode) ">
                            <span class="noTagText"> Plate Style Image Not Available</span>
                            </span>

                        </div>
                        <ul #selectOverlayDropdown [ngClass]="isDropdownOpen?'showDropdown':'hideDropdown'" class="dropdown-content select-dropdown select-overlay-dropdown" tabindex="0" id="select-overlay-dropdown">
                            <li (click)="changeCatalog(tagItem.tagCode)" [id]="tagItem.tagCode"  *ngFor="let tagItem of filterTagCatalogData" tabindex="0" class="">
                                
                            <span *ngIf="tagItem.tagCode && tagItem.imageCode && tagItem.name" style="display: flex;">

                                <img src="{{globalService.externalResourcesUrl}}dmv/{{getImage(tagItem.tagCode)}}.jpg" class="selectbox-icom" alt="{{tagItem.name}}"/>
                                <div style="padding-bottom:6px">
                                <div class="hdPlate">
                                    <span class="tagName" >
                                    {{tagItem.name}} 
                                    </span><span class="textLink showMore" tabindex="0" (click) = showHide(tagItem.tagCode)>{{!tagItemShowHide?.get(tagItem.tagCode)?'more':'less'}} </span>
                                </div>
                                 <div class="description" style="padding-left: 0px;" *ngIf="tagItemShowHide?.get(tagItem.tagCode)">
                                            {{tagItem.description}}
                                        </div>
                                        <!-- <div class="col-2" style="width:70px; padding-left: 4px; padding-right: 4px;"  *ngIf="tagItem.description?.length>70">
                                          <div class="textLink" tabindex="0" (click) = showHide(tagItem.tagCode)>{{!tagItemShowHide?.get(tagItem.tagCode)?'more':'less'}} </div>
                                        </div> -->
                            
                             <span class="tagAmmount">
                              Annual Fee:  {{tagItem.annualFee | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
                                </span>
                            <span class="tagAmmount" *ngIf="tagItem.processingFee">
                                Plus <span class="">{{(tagItem.processingFee || 0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}</span> processing fee per year
                                    </span>
      
                                </div>

                            </span>
                            <span *ngIf="!(tagItem.tagCode && tagItem.imageCode) " class="noTag">
                              Plate Style Image Not Available
                            </span>
                        
                        </li>
                           
                        </ul>
              
                    </div>
                </div>
                 <div class="row col-12 col-sm-12 mb-3 no-margin" *ngIf="filterTagCatalogData?.length>0" >
                
                <div class="col-6">
                    <div id="tampaBayBu"  [style.color]="(dmvStoreService.agencyConfigData$ | async)?.agencyDmvConfig?.primaryColor">{{tag?.name}}</div>
                </div>
                
                <div class="col-6">
                    <div id="data-encated-dollar">{{((tag?.annualFee)?tag.annualFee:0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}<br/>
                    <span class="annualCost">Annual Fee</span><br/>
                    <span class="tagPprocessingFee" *ngIf="tag.processingFee">
                        Plus <span class="feeAmount">{{(tag.processingFee || 0) | currency :'USD':'symbol':'1.2-2' | minusSignToParens}}</span> processing fee per year
                            </span>
                </div>
                
                </div>
                
                </div>
                   <div class="col-12 col-sm-12 mb-3" *ngIf="tagCategories?.length"> 
                        <div class="mb-5">
                            <a>
                                <button class="btn btn-primary btn-commonbtn m-auto" (click)="change()">Choose This Plate </button>
                            </a>
                     </div>  
                  </div>
              </div>   
            </section>      
        </div>

    </div>
  </div>
</div>